import ApiModel from './ApiModel'

class programming extends ApiModel {
}

export default new programming('/programming');